import onGetHospitalSelectors from './onGetHospitalSelectors';
import onGetHospitalCounters from './onGetHospitalCounters';
import onGetHospitalEvents from './onGetHospitalEvents';
import onGetMoreHospitalEvents from './onGetMoreHospitalEvents';
import onGetHospitalDetails from './onGetHospitalDetails';

export default {
  onGetHospitalSelectors,
  onGetHospitalCounters,
  onGetHospitalEvents,
  onGetMoreHospitalEvents,
  onGetHospitalDetails,
};
